<template>
  <b-sidebar
    id="unit-log-sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    no-close-on-backdrop
    right
    @shown="$emit('shown')"
    @hidden="$emit('hidden')"
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0 text-capitalize">
          {{ (isAdd ? $t('actions.add') : $t('actions.edit')) + ' ' + $t('patrol_logs.revision_code.title') }}
        </h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <div class="p-2">
        <unit-log-form
          :form-data="formData"
          :is-add="isAdd"
          @submit="$emit('submit')"
          @reset="hide"
        />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar } from 'bootstrap-vue'
import UnitLogForm from './Form.vue'

export default {
  components: {
    BSidebar,
    UnitLogForm,
  },
  model: {
    prop: 'isSidebarActive',
    event: 'update:is-sidebar-active',
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
  },
}
</script>
